import {
  EcommerceMerchantAction,
  LOAD_ECOMMERCE_MERCHANT_HASH,
  LOAD_ECOMMERCE_MERCHANT_HASH_FAIL,
  LOAD_ECOMMERCE_MERCHANT_HASH_SUCCESS,
  LoadEcommerceMerchantHash, LoadEcommerceMerchantHashFail,
  LoadEcommerceMerchantHashSuccess
} from "../actions";

export interface IEcommerceMerchantHashEntityState {
  existingMerchantHash?: any,
  loading: boolean;
  loaded: boolean;
}

export interface IEcommerceMerchantHashState {
  entities: { [websiteId: number]: IEcommerceMerchantHashEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommerceMerchantHashState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommerceMerchantHashState = initialState, action: EcommerceMerchantAction): IEcommerceMerchantHashState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_MERCHANT_HASH:
      payload = (<LoadEcommerceMerchantHash>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_MERCHANT_HASH_SUCCESS:
      payload = (<LoadEcommerceMerchantHashSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            existingMerchantHash: payload.existingMerchantHash,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_MERCHANT_HASH_FAIL:
      payload = (<LoadEcommerceMerchantHashFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
